import axios from 'axios';
import config from "@/config";
import store from "@/store";

const EXTENSION_SRC = /(chrome|moz|safari|safari-web)-extension:\/\//
const SAME_ERROR_INTERVAL = 5 * 60 * 1000
const MAX_PER_MINUTE = 10

const lastSent = new Map()
let minuteStart = 0
let minuteCount = 0

export function sendError(data) {
    if (EXTENSION_SRC.test(`${data.stack || ''} ${data.file || ''}`)) return

    let now = Date.now()
    let key = [data.type, data.message, data.status, data.method, data.url].join('|')
    if (now - (lastSent.get(key) || 0) < SAME_ERROR_INTERVAL) return
    if (now - minuteStart >= 60 * 1000) {
        minuteStart = now
        minuteCount = 0
    }
    if (minuteCount >= MAX_PER_MINUTE) return
    minuteCount++
    lastSent.set(key, now)

    axios.post(
        config.api.errorURL,
        {
            hostName: window.location.hostname,
            appUserId: store.getters.getAppUserId,
            ...data
        }
    ).catch((error) => console.error(error))
}
